<template>
    <div class="footer wow fadeInUp">
        <div class="rowFluid">
            <div class="span12">
            <div class="container">
                <div class="footer_content">
                <div class="span3 col-xm-12">
                    <div class="footer_list">
                    <div class="span6">
                        <div class="bottom_logo"> <img :src="picData[0]" /></div>
                    </div>
                    </div>
                </div>
                  <div class="span6 col-xm-12">
                    <div class="quick_navigation">
                      <div class="quick_navigation_title"> &nbsp;</div>
                      <ul >

                        <li> <a href="/" title="Top">ホーム</a> </li>
                        <li> <a href="/#/service" title="サービス概要">サービス概要</a> </li>
                        <li> <a href="/#/security" title="情報セキュリティ">情報セキュリティ</a> </li>
                        <li> <a href="/#/company" title="会社情報">会社情報</a> </li>
                        <li> <a href="/#/recruit" title="採用情報">採用情報</a> </li>
                        <li> <a href="/#/contact" title=" お問い合わせ"> お問い合わせ</a> </li>
                      </ul>
                    </div>
                  </div>

                <div class="span3 col-xm-6 col-xs-12">
                    <div class="footer_list">
                    <div class="footer_cotact">
                        <div class="footer_cotact_title" style="letter-spacing: 3px">CONTACTS</div>
                        <ul>
                        <li style="margin-bottom: auto"><span class="footer_cotact_type">Tel.</span><span class="footer_cotact_content">047-317-6276</span></li>
                        <li style="margin-bottom: auto"><span class="footer_cotact_type">E-mail.</span><span class="footer_cotact_content">contactus@lifefun.co.jp</span></li>
                        </ul>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div class="copyright">Copyright(c) Life&Fun Inc. </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            picData: [
                require('../../assets/images/logo_new4.png')
            ]
        }
    }
}
</script>
<style lang="less" rel="stylesheet/less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/footerBar/footerBar.vue